// extracted by mini-css-extract-plugin
module.exports = {"container":"blog-home-hero-article-carousel_container__UXxx_","box":"blog-home-hero-article-carousel_box__68PJQ"};